// 路由单元
export function route(path, name, component, options = {}) {
  // 切换路由
  if (options.isAudit) {
    component = getEmptyComponent()
  }
  const meta = options
  return {
    path, name, component, ...options, meta
  }
}

function getEmptyComponent() {
  return resolve => require(['@/pages/common/views/goods-empty'], resolve)
}
